import { render } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { inputs } from '../../../state/slices/formSlice'
import React from 'react'

const Select = (props) => {
    let modulo = props.modulo
    let index = props.index
    let subModulo = props.subModulo
    let indexSub = props.indexSub
    const dispatch = useDispatch()
    const modo = useSelector((state) => state.addForm.modo)
    const ficha = useSelector((state) => state.addForm.ficha)
    const mediaWeb = window.matchMedia("(min-width:600px)").matches
    const widthDiv = mediaWeb ? props.widthDiv : props.widthMobile
    const width = mediaWeb ? props.widthWeb : props.widthMobile

    const estilo = {
        principal: {
            display: props.componentDisplay || "block", width: widthDiv, marginRight: props.marginR, marginTop: "3vh",
            textAlign: "left", color: "#484848"
        },
        input: {
            width: width, backgroundColor: "#00000000", border: "1px solid #00000029", borderRadius: "5px",
            minHeight: "5px"
        }
    }

    return (
        <>{RenderInput()}</>
    )

    function RenderInput() {
        let object = []
        if (ficha[modulo] && ficha[modulo][index]) {
            if (ficha[modulo][index][subModulo]) var valor = ficha[modulo][index][subModulo][indexSub]
            else var valor = ficha[modulo][index][props.nome]
        }
        if (!valor) {
            object.push(
                <>
                    <div style={estilo.principal}>
                        <div>{props.label}</div>
                        <select style={estilo.input} name={props.nome}
                            onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))} >
                            {Options()}
                        </select>
                    </div>
                </>
            )
        }
        else if (valor && modo === "view") {
            object.push(
                <>
                    <div style={estilo.principal}>
                        <div>{props.label}</div>
                        <div style={estilo.input}>{valor}</div>
                    </div>
                </>
            )
        }
        else {
            object.push(
                <>
                    <div style={estilo.principal}>
                        <div>{props.label}</div>
                        <select style={estilo.input} name={props.nome}
                            defaultValue={valor}
                            onChange={e => dispatch(inputs({ e, modulo, index, subModulo, indexSub }))} >
                            {Options()}
                        </select>
                    </div>
                </>
            )
        }
        return object
    }

    function Options() {
        let list = [<option value=""></option>]
        props.array.map(el => {
            list.push(
                <option value={el}>{el}</option>
            )
        })
        return list
    }
}

export default Select